import { render, staticRenderFns } from "./AttendanceDialog.vue?vue&type=template&id=b24119ca"
import script from "./AttendanceDialog.vue?vue&type=script&lang=js"
export * from "./AttendanceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports